// extracted by mini-css-extract-plugin
module.exports = {"toggler":"ToggleButton_toggler__2YB5e","active":"ToggleButton_active__TKSVT","notactive":"ToggleButton_notactive__3ucf_","switch":"ToggleButton_switch__2buE-"};